import { Link, useLocation } from '@tanstack/react-router'
import { MapPin, Search, Settings, Snowflake, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

function useNavItems() {
  const { t } = useTranslation()
  return [
    { path: '/', label: t('nav.map'), icon: MapPin },
    { path: '/search', label: t('nav.search'), icon: Search },
    { path: '/snow-hunt', label: t('nav.snowHunt'), icon: Snowflake },
    { path: '/profile', label: t('nav.accounts'), icon: Users },
    { path: '/settings', label: t('nav.settings'), icon: Settings },
  ]
}

export function BottomNav() {
  const location = useLocation()
  const currentPath = location.pathname
  const navItems = useNavItems()

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      <div className="mx-auto flex h-16 max-w-screen-md items-center justify-around px-2 pt-2">
        {navItems.map((item) => {
          const Icon = item.icon
          const isActive = currentPath === item.path

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex flex-col items-center justify-center gap-1 rounded-lg px-4 py-2 transition-colors',
                'min-w-[60px] flex-1',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <Icon
                className={cn(
                  'h-5 w-5 transition-transform',
                  isActive && 'scale-110',
                )}
              />
              <span
                className={cn(
                  'text-xs font-medium transition-all',
                  isActive && 'font-semibold',
                )}
              >
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
